<template>
  <div v-if="items.length > 0" class="form-wishlist">
    <p class="form-wishlist__title">Prodotti selezionati</p>
    <ul class="form-wishlist__list">
      <li v-for="item in items" :key="item.id" class="form-wishlist__item">
        <img :src="item.image" :alt="item.title" class="form-wishlist__img" />
        <div class="form-wishlist__info">
          <strong class="form-wishlist__item-title">{{ item.title }}</strong>
          <span class="form-wishlist__item-name">{{ item.name }}</span>
        </div>
        <button type="button" class="form-wishlist__remove" @click="remove(item.id)" aria-label="Rimuovi">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M262.2 48C248.9 48 236.9 56.3 232.2 68.8L216 112L120 112C106.7 112 96 122.7 96 136C96 149.3 106.7 160 120 160L520 160C533.3 160 544 149.3 544 136C544 122.7 533.3 112 520 112L424 112L407.8 68.8C403.1 56.3 391.2 48 377.8 48L262.2 48zM128 208L128 512C128 547.3 156.7 576 192 576L448 576C483.3 576 512 547.3 512 512L512 208L464 208L464 512C464 520.8 456.8 528 448 528L192 528C183.2 528 176 520.8 176 512L176 208L128 208zM288 280C288 266.7 277.3 256 264 256C250.7 256 240 266.7 240 280L240 456C240 469.3 250.7 480 264 480C277.3 480 288 469.3 288 456L288 280zM400 280C400 266.7 389.3 256 376 256C362.7 256 352 266.7 352 280L352 456C352 469.3 362.7 480 376 480C389.3 480 400 469.3 400 456L400 280z"/></svg>
        </button>
      </li>
    </ul>
    <input type="hidden" name="RequestForm[wishlist]" :value="serialized" />
  </div>
</template>

<script>
const STORAGE_KEY = 'ideaerre_wishlist';

export default {
  name: 'FormWishlist',
  data() {
    return { items: [] };
  },
  computed: {
    serialized() {
      return JSON.stringify(this.items);
    },
  },
  mounted() {
    if (document.querySelector('#alerttw.alert-success')) {
      localStorage.removeItem(STORAGE_KEY);
      window.dispatchEvent(new CustomEvent('wishlist:updated'));
    }
    this.load();
    window.addEventListener('wishlist:updated', this.load);
  },
  beforeUnmount() {
    window.removeEventListener('wishlist:updated', this.load);
  },
  methods: {
    load() {
      this.items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    },
    remove(id) {
      this.items = this.items.filter(p => p.id !== id);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.items));
      window.dispatchEvent(new CustomEvent('wishlist:updated'));
    },
  },
};
</script>
